import Swiper, { Autoplay, EffectFade, Lazy, Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/**
 * スライダー関連の処理
 */
export default class Slider {
  constructor() {
    this.pickupSlider();
    this.aboutLoopSlider();
  };

  /**
   * ピックアップ（TOP）スライダー
   */
  pickupSlider() {
    const sliderMain = new Swiper('.js-pickup-main-slider', {
      modules: [Autoplay, EffectFade, Lazy, Pagination, Navigation],
      loop: true,
      slidesPerView: 'auto',
      speed: 500,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.js-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.js-slide-next',
        prevEl: '.js-slide-prev',
      },
      preloadImages: false,
      lazy: true,
      watchSlidesProgress: true
    });

    const sliderThumb = new Swiper('.js-pickup-thumb-slider', {
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      speed: 500
    });

    // サムネイルスライダー 連動
    sliderMain.on('realIndexChange', () => {
      sliderThumb.slideToLoop(sliderMain.realIndex);
    });
  };

  /**
   * 店通について スライダー
   */
  aboutLoopSlider() {
    const loopSlider = new Swiper('.js-about-loop-slider', {
      modules: [Autoplay],
      loop: true,
      slidesPerView: 'auto',
      speed: 8000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      }
    });
  };
}
